import ModalBase from 'react-modal'
import styled from 'styled-components'

export const Title = styled.h1`
  font-weight: bold;
  font-size: 22px;
  line-height: 29px;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
`

const Modal = styled(ModalBase)<{ modalWidth?: number }>`
  background: ${({ theme }) => theme.colors.backgroundDisabled};
  padding: 20px 24px;
  box-shadow: 0px 6px 4px rgba(0, 0, 0, 0.25);
  position: absolute;
  text-align: center;
  top: 10%;

  :focus {
    outline: unset;
  }

  ${({ modalWidth = 325 }) => `
    width: ${modalWidth}px;
    left: calc(50% - ${modalWidth}px / 2);
  `}
`
export default Modal
